import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const reasonListTodo = createAsyncThunk('reasonList', async (data) => {
    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'reasons',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },
        })

        return res

    } catch (error) {
        return error?.response
    }
});

const reasonListSlice = createSlice({
    name: 'reasonList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(reasonListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status == 401) {
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = []
            }
        });
        builder.addCase(reasonListTodo.rejected, (state, action) => {
        })
    }
});

export default reasonListSlice.reducer;


